export const MICROSITE_PATH = '/m'

export const SITE_URL =
  process.env.VERCEL_ENV === 'production'
    ? `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
    : process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:8080'

export function getMicrositePath(micrositeUrl: string) {
  return `${MICROSITE_PATH}/${micrositeUrl}`
}

export function getMicrositeUrl(micrositeUrl: string) {
  return `${SITE_URL}${getMicrositePath(micrositeUrl)}`
}

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_IS_PRODUCTION === '1'
